// UKOI — client-side фільтрація каталогу (sidebar). Мала колекція (~до 50 товарів).
(function () {
  const root = document.querySelector('ukoi-catalog, .ukoi-catalog');
  if (!root) return;

  const GROUPS = ['type', 'line', 'needs', 'skin', 'act', 'rout', 'time'];
  const cards = Array.from(root.querySelectorAll('.ukoi-card'));
  const boxes = Array.from(root.querySelectorAll('input[type="checkbox"][data-group]'));
  const countEl = root.querySelector('.ukoi-count strong');
  const emptyEl = root.querySelector('.ukoi-empty');

  function selected() {
    const sel = {};
    for (const g of GROUPS) sel[g] = new Set();
    for (const b of boxes) if (b.checked) sel[b.dataset.group].add(b.value);
    return sel;
  }

  function apply() {
    const sel = selected();
    let visible = 0;
    for (const card of cards) {
      let show = true;
      for (const g of GROUPS) {
        if (sel[g].size === 0) continue;
        const vals = (card.dataset[g] || '').split('|').filter(Boolean);
        // OR всередині групи: картка має хоч одне обране значення
        if (!vals.some((v) => sel[g].has(v))) { show = false; break; }
      }
      card.hidden = !show;
      if (show) visible++;
    }
    if (countEl) countEl.textContent = visible;
    if (emptyEl) emptyEl.hidden = visible !== 0;
  }

  boxes.forEach((b) => b.addEventListener('change', apply));

  const clear = root.querySelector('.ukoi-clear');
  if (clear) clear.addEventListener('click', () => { boxes.forEach((b) => (b.checked = false)); apply(); });

  // мобільний drawer + доступність (inert/фокус/Esc)
  const open = root.querySelector('.ukoi-filter-open');
  const close = root.querySelector('.ukoi-filter-close');
  const sidebar = root.querySelector('.ukoi-catalog__sidebar');
  const mq = window.matchMedia('(max-width: 749px)');

  function setInert() {
    if (!sidebar) return;
    if (mq.matches && !root.classList.contains('is-open')) sidebar.setAttribute('inert', '');
    else sidebar.removeAttribute('inert');
  }
  function openDrawer() {
    root.classList.add('is-open');
    if (open) open.setAttribute('aria-expanded', 'true');
    setInert();
    if (close) close.focus();
  }
  function closeDrawer() {
    root.classList.remove('is-open');
    if (open) open.setAttribute('aria-expanded', 'false');
    setInert();
    if (open) open.focus();
  }
  if (open) open.addEventListener('click', openDrawer);
  if (close) close.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && root.classList.contains('is-open')) closeDrawer(); });
  if (mq.addEventListener) mq.addEventListener('change', setInert);
  setInert();
})();
